import { Box, Stack, Typography } from "@mui/material";
import { rankFormat } from "~/lib/number-k-formatting";
import { FleetIcon } from "~/icons";
import { PriorityFindingsDeltaPercentage } from "~/pages/space/home-dashboard/PriorityFindingsCard/components/PriorityFindingsDeltaPercentage";

interface PriorityFindingsCardStatsProps {
  findingsCount: number;
  findingsDelta: number | undefined;
  findingsDeltaPercentage: number | undefined;
  assetCount: number;
  assetCountDelta: number;
  assetDeltaPercentage: number;
}

export const PriorityFindingsCardStats = ({
  findingsCount,
  findingsDelta,
  findingsDeltaPercentage,
  assetCount,
  assetCountDelta,
  assetDeltaPercentage,
}: PriorityFindingsCardStatsProps) => (
  <Stack direction="column" gap={1}>
    <Box sx={{ gap: 1, display: "flex", flexDirection: "column" }}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Stack direction="row" gap={2} alignItems="center">
          <Typography
            fontSize={32}
            fontWeight={700}
            data-testid="priority-findings-count"
          >
            {rankFormat(findingsCount)}{" "}
          </Typography>

          {findingsDelta !== undefined && (
            <Typography
              component="span"
              variant="h5"
              fontWeight={700}
              color="text.secondary"
            >
              ({findingsDelta > 0 ? "+" : ""}
              {rankFormat(findingsDelta)})
            </Typography>
          )}
        </Stack>

        {findingsDeltaPercentage !== undefined && (
          <PriorityFindingsDeltaPercentage
            deltaPercentage={findingsDeltaPercentage}
            deltaCount={findingsDelta || 0}
            color="primary"
            testId="percentage-change"
          />
        )}
      </Box>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" gap={0.5}>
          <FleetIcon sx={{ fontSize: 16 }} />
          <Typography
            component="p"
            variant="subtitle2"
            sx={{ lineHeight: "22px" }}
          >
            Asset Count
          </Typography>
        </Stack>

        <Box display="flex" alignItems="center" gap={2}>
          <Typography
            data-testid="priority-findings-assets-count"
            fontWeight={600}
            fontSize={18}
          >
            {rankFormat(assetCount)}
          </Typography>

          <Typography
            component="p"
            variant="subtitle2"
            fontWeight={500}
            color="text.secondary"
          >
            ({assetCountDelta > 0 ? "+" : ""}
            {rankFormat(assetCountDelta)})
          </Typography>

          <PriorityFindingsDeltaPercentage
            deltaPercentage={assetDeltaPercentage}
            deltaCount={assetCountDelta}
            color="secondary"
            testId="asset-percentage-change"
            small
          />
        </Box>
      </Box>
    </Box>
  </Stack>
);
